
// prop-types is library for typechecking of props
import PropTypes from "prop-types";

// Material Dashboard 2 PRO React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import "./chart.css"
import { useTranslation } from 'react-i18next';
import ChartItemPlanet from "./ChartItemPlanet";
import { useEffect, useRef } from "react";

function ChartKendaraya({ planets, gender, devision, lagna, lagnaSputaya, rashiId, arudhaPadas }) {
    const { t } = useTranslation();
    // Set CSS variable for --z1-image based on your requirements

    const containerRef = useRef(null);

    useEffect(() => {
        if (containerRef.current) {
            console.log("Setting background image for container");
            // Place Z2.jpeg in the public/assets/images/Chart/ directory
            if(rashiId){

                containerRef.current.style.setProperty(
                    "--z1-image",
                    `url('/images/Chart/Z${rashiId}.jpeg')`
                );
            }
        }
    }, []);

    // Determine dynamic class and background color based on gender
    const genderClass = gender === 'F' ? 'gender-female' : gender === 'M' ? 'gender-male' : '';
    const genderBgColor = gender === 'F' ? { backgroundColor: '#ffe6f0' } : gender === 'M' ? { backgroundColor: '#e6f0ff' } : {backgroundColor: '#f0f0f0'};

    return (
        <div className={`chat-container`} style={genderBgColor}>
            <div className="size-constrains">
                <MDTypography variant="h6" fontWeight="medium">
                    {(devision == 'D1') && <span>
                        {(gender == 'F') && <span>{t("Female")}</span>}
                        {(gender == 'M') && <span>{t("Male")}</span>}  {t('LAGNA') + ' ' + t('KENDARAYA')}</span>}
                    {(devision == 'D9') && <span><span translate>{t('NAWANSAKA') + ' '}</span><span translate>{t('KENDARAYA')}</span></span>}
                </MDTypography>
            </div>
            <div className="container" ref={containerRef} >
                <div className="container container-image">
                    <div className="position0">
                        <strong>
                            {devision == 'D1' && <>{t('LAGNAYA')}</>}
                            {devision == 'D9' && <>{t('NAWANSAKAYA')}</>}
                        </strong>
                        <br />
                        <strong>{lagna}<br />{lagnaSputaya}</strong>
                    </div>
                    {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].map((n, index) => (
                        <>
                        <div className={"position" + n} key={index}>
                            {planets.map((item, idx) =>
                            (n === (devision === 'D1' ? item.bhawaIndex : item.bhawaIndexNasansaka)
                                && (
                                    <ChartItemPlanet key={idx} planetData={item} />
                                )
                            ))}
                        </div>
                        {/* <div className={"positionALs" + n} key={index}>
                            {devision === 'D1' && (
                                <>
                                    {arudhaPadas.filter(item => item.house === n).map((item, idx) => (
                                        <span key={idx}>{item.key}{idx < arudhaPadas.filter(item => item.bhawaIndex === n).length - 1 ? ', ' : ''}</span>
                                    ))}
                                </>
                            )}
                        </div> */}
                        </>
                    ))}
                </div>
            </div>
        </div>
    );
};


// Typechecking props for the MiniInfoCard
ChartKendaraya.propTypes = {
    planets: PropTypes.array,
    gender: PropTypes.string,
    devision: PropTypes.string,
    lagna: PropTypes.string,
    rashiId: PropTypes.string,
    lagnaSputaya: PropTypes.string,
    arudhaPadas: PropTypes.array,
};

export default ChartKendaraya;
